
import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import _ from 'lodash';


import { Divider } from '../../ecosystem';
import * as types from "../../../constants/actionTypes";
import * as msgs from "../../../constants/textConstants";
import * as d from "../../../reducers/domainReducer";
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import { rxRoute } from "../../../helpers/formatting";
import ServiceDownBanner from '../../common/ServiceDownBanner';
import { getSiteMenuItems } from './MenuItems/MyBSW.js';
import { getHealthPlanName, getProfileName } from './MenuItems/Utils.js';
import Nav from './Nav';
import Logo from '../../header/Logo';

/* eslint-disable react/prop-types */
/**
 * Main app menu. Expects props to contain an array of strings identifying the menu items to enable.
 */
class Menu extends React.Component {

    constructor(props) {
        super(props);

        this.toggleMainMenu = this.toggleMainMenu.bind(this);
        this.hideMainMenu = this.hideMainMenu.bind(this);
        //this.mapOfActiveHead = this.mapOfActiveHead.bind(this);

        this.throttle = _.throttle(this.handleResize.bind(this), 150);


        this.patientId = null;
        this.currentPharmacyId = null;
        this.isMobile = false;
        this.windowHeight = 0;
        const location = window ? window.location.pathname === "/login" ? "/" : window.location.pathname : "/";
        const membershipsAuthorizedFeatures = this.getAuthorizedFeatures();
        //let activeMenuValues = this.mapOfActiveHead(location);
        let initialState = {
            activeMenu: location,
            //activeMenuHead: activeMenuValues.activeMenuHead,
            //activeSleekMenu: activeMenuValues.activeSleekMenu
        };
        if (initialState.activeSleekMenu !== "") {
            initialState = {
                ...initialState,
                showMainMenu: false
            };
        }

        this.state = {
            showMainMenu: false,//initialState.showMainMenu ? initialState.showMainMenu : false,
            activeMenu: initialState.activeMenu,
            //activeMenuHead: initialState.activeMenuHead,
            //activeSleekMenu: initialState.activeSleekMenu,
            membershipsAuthorizedFeatures: membershipsAuthorizedFeatures
        };
    }

    componentDidMount() {
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.throttle);
        }
    }

    componentDidUpdate(prevProps) {
        const { currentUser, currentPharmacyUser } = this.props;
        const patientId = currentUser ? currentUser.dn : null;
        const currentPharmacyId = currentPharmacyUser ? currentPharmacyUser.pharmacyPatientId : '';
        //update.

        if (patientId && patientId !== this.patientId) {
            this.patientId = patientId;
            this.handleResize();
        } else if (currentPharmacyId !== this.currentPharmacyId) {
            this.currentPharmacyId = currentPharmacyId;
            this.handleResize();
        }
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.throttle);
        }
        if (this.historyUnListen) {
            this.historyUnListen();
        }
    }

    /**
     *  @returns {object} an object only with the elements that start with hasAuthorizedFeature
     */
    getAuthorizedFeatures() {
        const af = Object.keys(window.store.getState().memberships).reduce((a, element) => {
            if (element.startsWith("hasAuthorizedFeature")) {
                a[element] = window.store.getState().memberships[element];
            }
            return a;
        }, {});
        return af;
    }
    updateMenus(prevProps) {
        const { currentLocation, updateMenu, hasHealthPlanLogin, hasAAL, hasFirstCare, isProxyUser } = this.props;
        let { activeMenu } = this.state;
        activeMenu = activeMenu ? activeMenu : "";
        const inPersonFindCare = location.href.indexOf("isUrgentCare=true") > -1;
        const actualPath = (location.pathname.split("/").length > 2) ? location.pathname.substring(0, location.pathname.indexOf("/", 2)) : location.pathname;
        const pathName = location ? location.pathname === "/login" ? "/" : actualPath : "/";
        let parentMenu = '';
        if (pathName === "/findcare") {
            if (inPersonFindCare) {
                parentMenu = this.getImmediateParent("findcarefrominperson");
            }
        }
        else {
            parentMenu = this.getImmediateParent(pathName);
        }

        //Depends on Health Plan roles updates and domain to domain validation check.
        const updateMenuForHealthPlans = (typeof prevProps !== 'undefined' && prevProps
            && ((prevProps.hasHealthPlanLogin !== hasHealthPlanLogin) || (prevProps.hasAAL !== hasAAL) || (prevProps.hasFirstCare !== hasFirstCare))) ? true : false;

        const updateMenuForProxyUsers = typeof prevProps !== 'undefined' && prevProps && prevProps.isProxyUser !== isProxyUser;

        if (activeMenu && updateMenuForHealthPlans || updateMenuForProxyUsers || (activeMenu.toLowerCase() !== pathName.toLowerCase() || currentLocation || (activeMenu.toLowerCase() === pathName.toLowerCase() && parentMenu))) {//handle refresh for non-navitem routes to select immediate parent if it has.
            if (!(parentMenu && parentMenu.toLowerCase() === activeMenu.toLowerCase() && activeMenu.toLowerCase() !== pathName.toLowerCase() && !currentLocation)) {
                if (pathName.toLowerCase().indexOf('findcare') > -1 && this.props.clearSearch) this.props.clearSearch();
                //let activeMenuValues = this.mapOfActiveHead((inPersonFindCare ? parentMenu : pathName));
                let membershipsAuthorizedFeatures = this.getAuthorizedFeatures();
                updateMenu("");//reset
                if (activeMenuValues && activeMenuValues.activeMenuHead) {
                    this.hideMainMenu();
                    this.setState({
                        activeMenu: parentMenu ? parentMenu : pathName,
                        //activeMenuHead: activeMenuValues.activeMenuHead,
                        //activeSleekMenu: activeMenuValues.activeSleekMenu,
                        membershipsAuthorizedFeatures: membershipsAuthorizedFeatures
                    });
                }
            }

        }
    }

    /* Sets Parent of Child Pages Not Directly in Menu */
    getImmediateParent(childRoute) {
        const { serverData } = this.props;
        const enabledVirtualDashboard = serverData && serverData.enableVirtualDashboardUpdates ? serverData.enableVirtualDashboardUpdates : false;
        const enableCustomDirectScheduling = serverData && serverData.enableCustomDirectScheduling;
        switch (childRoute.toLowerCase()) {
            //apply for all the routes which are not mapped to navitem.
            case "/proxyrequestdob":
            case "/proxyrequest":
            case "/grantaccessproxy":
            case "/acceptproxy":
                return "/proxyManagement";
            case "/schedule":
                return enableCustomDirectScheduling ? "/schedule/DirectSchedule" : "";
            case "/evisitnow":
            case "/evisittravel":
                return "/evisit";
            case "/aatravel":
                return "/videovisitscheduledfor";
            case "/admininfo":
                return "/demographics";
            case "/coverage":
                return "/insurance";
            case "/nonbswtransfer":
            case "/bswtransfer":
            case "/pharmacynonbswtransfer":
            case "/pharmacybswtransfer":
                return rxRoute('rxTransfer');
            case "findcarefrominperson": //this is not actual route
                return "/inperson";
            case "/schedulevideovisit":
                return enabledVirtualDashboard ? "/videovisitscheduledfor" : "/videoondemand";
            case "/preferencesettings":
                return "/notifications";
            case "/carecoachmessage":
                return "/carecompanion";
            case "/wellbeingmessage":
                return "/wellbeinginbox";
            case "/inhomeschedule":
                return "/inhomevaccine";
            default:
                return "";
        }
    }

    handleResize(event) {
        if (typeof window !== 'undefined') {
            let windowWidth = window.innerWidth;

            // Check if mobile 
            if (windowWidth <= 768) {
                this.isMobile = true;
            }
            else {
                this.isMobile = false;
            }
        }
    }

    /* Toggle Mobile Menu Open and Close */
    toggleMainMenu() {
        this.setState({
            showMainMenu: !this.state.showMainMenu
        });
    }

    /* Close Mobile Menu */
    hideMainMenu(type) {
        this.setState({
            showMainMenu: false
        });
    }

    showCareCoach() {
        const { enableCareCompanion } = this.props;
        return enableCareCompanion;
    }


    /*mapOfActiveHead: Set Active Menu Head and Sleek Submenu  moved to hook in Nav*/  

    setOutageMsg(displayEpicError, displaySWHPError, displayRXError, displayAALError) {
        if (displayEpicError || displaySWHPError || displayRXError || displayAALError) {
            if (displayEpicError && !displaySWHPError && !displayRXError && !displayAALError) {
                return "Medical records unavailable. Try again later.";
            } else {
                return "Some records unavailable. Try again later.";
            }
        } else {
            return '';
        }

    }
    render() {
        const {  hasMyChart, bundle, currentPharmacyUser, isProxyUser, hasHealthPlanLogin, hasAAL,  showCustomBanner,
            hasPharmacyLogin,  epicEHRDown, swhpDown, rxDown, aalDown,  enablePrayerFeature, isActiveFeature_Amity,
        } = this.props;


        const { showMainMenu, activeMenuHead, activeSleekMenu, activeMenu } = this.state;

        //console.info(`Menu render showMainMenu '${showMainMenu}' activeMenuHead '${activeMenuHead}' activeSleekMenu '${activeSleekMenu}' activeMenu '${activeMenu}'`);
/***/  const pathname = typeof window !== "undefined" ? window.location.pathname.toLowerCase() : "";
/***/  const isPharmacy = bundle === "pharmacy" || pathname.indexOf('/pharmacy') === 0;
/***/  const isMyBSWHealth = bundle === "mybswhealth" && !isPharmacy;
        const isMyChartProxyUser = isProxyUser;
/***/  const notPharmacyProxy = isMyBSWHealth || isPharmacy && !currentPharmacyUser;
        

        //const enableAALElements = serverData.enableAA && hasAAL;
        const mobileMenuOpenClass = (showMainMenu ? " menu-open" : " menu-closed");
        
        // Set error message and visibility
        const displayEpicError = (notPharmacyProxy && hasMyChart) && epicEHRDown;
        const displaySWHPError = (notPharmacyProxy && !hasAAL && hasHealthPlanLogin && !isMyChartProxyUser) && swhpDown;
        const displayRXError = ((hasPharmacyLogin && !isMyChartProxyUser) || currentPharmacyUser) && rxDown;
        const displayAALError = (notPharmacyProxy && hasAAL && !isMyChartProxyUser) && aalDown;
        const serviceDownMsg = this.setOutageMsg(displayEpicError, displaySWHPError, displayRXError, displayAALError);
        

        const siteMenuItems = getSiteMenuItems(this.props,this.state);

        return ( <div data-element-id="main menu container" className={"menu main-menu-container" + mobileMenuOpenClass}>
                <div data-element-id="menu header" className="menu-header">
                    <div className="main-menu-header">
                        
                        <div className="menu-btn" onClick={this.toggleMainMenu}>
                            <div className="hamburger">
                                <div className="hamburger-inner">
                                    <span />
                                    <span />
                                    <span />
                                </div>
                            </div>
                        </div>
                        <div className="main-menu-logo">
                            <Logo />
                        </div>
                    </div>
                    {/*showMainMenu && serviceDownMsg !== '' &&
                        <ServiceDownBanner className="menu-service-down" message={serviceDownMsg} />
                    */}
                </div>
                <div data-element-id="menu list" className={"menu-list " /*+ (activeSleekMenu !== "" ? "sleek-menu-open" : "")*/}>
                <Nav siteMenuItems={siteMenuItems} activeMenu={activeMenu} currentPharmacyUser={currentPharmacyUser} onMenuChange={() => { }} toggleMainMenu={() => { this.toggleMainMenu() } } />
                {/*<Nav siteMenuItems={siteMenuItems} activeMenu={activeMenu} currentPharmacyUser={currentPharmacyUser}
                    onMenuChange={(m) => {
                        this.setState({ activeMenu: m.url });
                    if (m.url.trim().length > 0 && this.isMobile) {
                        this.toggleMainMenu();
                    }
                    }}
                />*/}
                <Divider
                    style={{marginTop: '-15px' } }
                    mRight="none"
                    mTop="none"
                    mLeft="none"
                    orientation="vertical"
                    size="auto"
                    />
                    
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        serverData: state.session.serverData,
        canAccessThrive: state.domain.ct,
        isEmployee: state.domain.ie,
        hasMyChart: state.domain.hm,
        hasHealthPlanLogin: state.memberships.hasAnySWHP,
        hasFirstCare: state.memberships.hasFC,
        hasAAL: state.memberships.hasAA,
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        swhp: state.memberships.amiSWHPMembershipId, //amisys swhp id
        epicEHRDown: state.common.epicEHRDown,
        //enableCareCompanion: state.session.serverData && state.session.serverData.enableCareCompanion,
        enableCareCompanion: state.memberships.enableCareCompanion,
        swhpDown: state.common.swhpDown,
        rxDown: state.common.rxDown,
        aalDown: state.common.aalDown,
        bundle: state.session.serverData ? state.session.serverData.bundle : "mybswhealth",  // we'll default with rendering for mybswhealth
        isProxyUser: state.domain.ip,
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        currentUser: state.domain.cu,
        healthPlanUrl: state.session.serverData.healthPlanApiUrl + '#/?t=' + encodeURIComponent(state.domain.t),
        thriveData: state.thrive.card,
        thriveDataSuccess: state.thrive.cardSuccess,
        showCustomBanner: state.domain.sb,
        currentLocation: state.common.currentLocation,
        sameDayVideoVisitScheduleEnabled: state.session.serverData.sameDayVideoVisitScheduleEnabled,
        hpIdentity: state.session.healthPlanUserProfile, // still coming from token (indirectly)? i dont think this is available in memberships
        isMemberPayer: state.domain.hpp, // still coming from token? i dont think this is available in memberships
        dentalInvoice: state.session.hasADental,
        bffDashboardData: state.dashboard.bffDashboardData,
        enablePricingTransparency: isEnabled(state),
        isActiveFeature_EVisit: state.memberships.isActiveFeature_EVisit,
        isActiveFeature_AmbulatoryVideoVisit: state.memberships.isActiveFeature_AmbulatoryVideoVisit,
        isActiveFeature_SDCVideoVisit: state.memberships.isActiveFeature_SDCVideoVisit,
        hasAuthorizedFeatureSameDayVideo: state.memberships.hasAuthorizedFeatureSameDayVideo,
        hasAuthorizedFeatureMyConditions: state.memberships.hasAuthorizedFeatureMyConditions,
        isActiveFeature_InsuranceModule: state.memberships.hasAA || state.memberships.hasAnySWHP || state.memberships.hasFC || (state.memberships.hasDART && state.memberships.isActiveFeature_InsuranceModule) || (state.memberships.hasWACO && state.memberships.isActiveFeature_InsuranceModule),
        isActiveFeature_OnlineAppointmentScheduling: state.memberships.isActiveFeature_OnlineAppointmentScheduling,
        insuranceTabText: state.memberships.insuranceTabText,
        enablePrayerFeature: state.session.serverData && state.session.serverData.enablePrayerFeature,
        isActiveFeature_Amity: state.memberships.activeFeatures && state.memberships.activeFeatures.amity,
        enableInHomeFeature: state.session.serverData.enableInHomeFeature && (state.memberships.isActiveFeature_InHomeVaccine || (!state.domain.ip && state.memberships.isActiveFeatureAnyone_InHomeVaccine)),
        activeProfile: state.memberships.activeProfile,
        myChartAuthorizedEpicFeatures: state.session.serverData.myChartAuthorizedEpicFeatures.replace("&#xD;&#xA;", "").unescapeHTML(),
        Covid19AgeForVaccine: state.session.serverData.Covid19AgeForVaccine ? state.session.serverData.Covid19AgeForVaccine : 12,
        isMedicalAdvice: state.memberships.hasAuthorizedFeatureMedicalAdvice,
        EnableProfileDashboard: state.session.serverData && state.session.serverData.EnableProfileDashboard ? true : false,
        isMyChartInActive: state.dashboard.isMyChartInActive
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLogoutClick: () => {
            dispatch({ type: types.LOGOUT, logoutMessage: msgs.UserInitiatedLogoutMessage });
        },
        clearSearch: () => {
            dispatch({ type: types.SEARCH_PROVIDER_CLEAR });
            dispatch({ type: types.SEARCH_LOCATION_CLEAR });
        },
        updateMenu: (currentLocation) => dispatch({ type: types.UPDATE_MENU, currentLocation }),
    };
};
const isEnabled = (state) => {

    let enabled = state.session.serverData.enablePricingTransparency ? state.session.serverData.enablePricingTransparency : false;
    let enablingUser = window.currentUserName === state.session.serverData.enablingPricingTranparencyUser ? true : false;
    return enabled || enablingUser;
}
const MenuHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(Menu);

/* eslint-enable react/prop-types */
export default withRouter(MenuHOC);